/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementSettingEventResponse } from './EventManagementSettingEventResponse';

export type EventManagementSettingEventResponseApiRespoonse = {
    data?: EventManagementSettingEventResponse;
    status?: EventManagementSettingEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementSettingEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

